import { DataBean } from "../../DataBean";


export class PatientDischargeStatus extends DataBean {


    public async getPatientDischargeStatusCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPatientDischargeStatusCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}